<template>
  <van-cell-group class="updateName">
    <van-field v-model="nickName" placeholder="请输入昵称" class="nickName"/>
    <van-col span="24" type="flex" justify="space-between" class="barBtn">
      <van-button round type="danger" size="large" class="ModifyName" @click="ModifyName">保存</van-button>
    </van-col>
  </van-cell-group>
</template>

<script>
  import { Toast } from 'vant';
  import { reqUpdateInfo } from '../../api'
	export default {
    name:"updatename",
    data () {
      return {
        nickName:'',
        userId:''
      }
    },
    created(){
      this.userId = this.$cookies.get('userInfo').userId
    },
    methods:{
      ModifyName () {
        let _that = this
        let InfoData = {
          userId:this.userId,
          nickName:this.nickName
        }
        reqUpdateInfo(InfoData).then(res => {
          if(res.success){
            this.$cookies.remove('userInfo');
            this.$cookies.set('userInfo',res.data);
            Toast.success({message:'保存成功！',className:'apiLoading',onClose:function(){
                _that.$router.push({
                  path:'/settings',
                  name:'settings'
                })
            }});
          }else {
            Toast.fail({message:'服务暂停！',className:'apiLoading'});
          }
        })
      },
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "../../common/stylus/mixins.styl"
  .updateName
    .van-cell-group
      background #f9f9f9
      padding-top 16px
    .nickName
      height 98px
      background #ffffff
      input
        height 80px
        line-height 80px
        font-size 26px
        padding-left 20px
    .barBtn
      padding 20% 40px 0px
      .ModifyName
        color #ffffff
        font-size 32px
        background #ff6d02
        height 88px
        margin-top 100px
        line-height 88px
</style>



// WEBPACK FOOTER //
// src/pages/Settings/UpdateName.vue